module.exports = "<p>\n  manual-lottery works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/allocation/manual-lottery/manual-lottery.component.html
// module id = ./src/app/allocation/manual-lottery/manual-lottery.component.html
// module chunks = main